/**
 * PublicLayout - Wrapper for public pages with header and footer
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PublicHeader from '@/components/PublicHeader';
import PublicFooter from '@/components/PublicFooter';
import SiteAnalytics from '@/components/SiteAnalytics';

export default function PublicLayout({ children, onShowEnquiry, onShowQuickEnquiry }) {
  return (
    <div className="public-site min-h-screen flex flex-col bg-white overflow-x-clip">
      <SiteAnalytics />
      <PublicHeader 
        onShowEnquiry={onShowEnquiry} 
        onShowQuickEnquiry={onShowQuickEnquiry} 
      />
      
      {/* Main Content - seamless connection with header */}
      <main className="flex-1 pb-20 md:pb-0">
        {children}
      </main>

      {/* Footer */}
      <PublicFooter />

      {/* Persistent mobile CTA — always one tap from converting ad traffic */}
      <Link
        to="/get-started"
        data-testid="mobile-sticky-cta"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 flex items-center justify-center gap-2 bg-[#0066CC] text-white font-semibold py-4 px-6 shadow-[0_-4px_20px_-4px_rgba(0,0,0,0.2)] active:bg-[#0055aa] transition-colors"
        style={{ paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))' }}
      >
        Get Early Access
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
